import { Component, OnInit } from '@angular/core';
import { RetalkService } from '../../services/retalk.service';
import { switchMap } from 'rxjs';

@Component({
  selector: 'app-retalk',
  templateUrl: './retalk.component.html',
  styleUrls: ['./retalk.component.css']
})
export class RetalkComponent implements OnInit {

  isDataLoaded: boolean = false;
  retalkData: any;
  orderedRetalkData: any[] = [];

  retalkStaticData: any;

  constructor(private retalkService: RetalkService
  ) { }

  ngAfterViewInit() { }

  ngOnInit(): void {
    this.retalkService.getRetalkStatic().pipe(
      switchMap((resp) => {
        this.retalkStaticData = JSON.parse(resp.data);
        return this.retalkService.getRetalkData();
      })
    )
      .subscribe(
        {
          next: (data: any) => {

            this.retalkData = data.data.retalks.rows;

            // Test if datePublishing is null or empty and in that case, test if date is less than today
            this.retalkData = data.data.retalks.rows.filter(podcast => podcast.status === 1 && (!podcast.datePublishing || podcast.datePublishing === "" || new Date(podcast.datePublishing) < new Date()));
            // Sort by date
            this.orderedRetalkData = this.retalkData.sort((a, b) => new Date(a.date!).getTime() - new Date(b.date!).getTime());
            this.isDataLoaded = true;
          },
          error: (error) => { }
        })
  }

}


